// extracted by mini-css-extract-plugin
export var divider = "_e0-7";
export var itemsToggle = "_e0-8";
export var mergeModal = "_e0-1";
export var optionCard = "_e0-4";
export var radioGroup = "_e0-6";
export var radioOption = "_e0-0";
export var selected = "_e0-5";
export var shipmentOptions = "_e0-2";
export var tableOptions = "_e0-3";